import * as imagesTout1 from "../images/bas-saint-laurent/index";
import * as imagesTout3 from "../images/becancour-sutton/index";
import * as imagesTout5 from "../images/charlevoix/index";
import * as imagesTout6 from "../images/cote-acadienne/index";
import * as imagesTout7 from "../images/cote-nord/index";
import * as imagesTout8 from "../images/fjord-du-saguenay-nord/index";
import * as imagesTout9 from "../images/fjord-du-saguenay-sud/index";
import * as imagesTout10 from "../images/gaspesie/index";
import * as imagesTout11 from "../images/ile-du-prince-edouard/index";
import * as imagesTout12 from "../images/iles-de-la-madeleine/index";
import * as imagesTout13 from "../images/la-verendrye/index";
import * as imagesTout15 from "../images/lac-st-jean/index";
import * as imagesTout16 from "../images/laurentides/index";
import * as imagesTout17 from "../images/mauricie/index";
import * as imagesTout18 from "../images/montreal-quebec-nord/index";
import * as imagesTout19 from "../images/montreal-quebec-sud/index";
import * as imagesTout20 from "../images/montreal-sherbrooke/index";
import * as imagesTout21 from "../images/outaouais-nord/index";
import * as imagesTout22 from "../images/outaouais-sud/index";
import * as imagesTout24 from "../images/portneuf/index";
import * as imagesTout25 from "../images/sentier-waterfront/index";
import * as imagesTout26 from "../images/sherbrooke-quebec/index";
import * as imagesTout27 from "../images/temiscouata/index";

let imagesTout0, imagesTout2, imagesTout4, imagesTout14, imagesTout23, imagesTout28, imagesTout29;

const imagesTout = [
    imagesTout0,
    imagesTout1,
    imagesTout2,
    imagesTout3,
    imagesTout4,
    imagesTout5,
    imagesTout6,
    imagesTout7,
    imagesTout8,
    imagesTout9,
    imagesTout10,
    imagesTout11,
    imagesTout12,
    imagesTout13,
    imagesTout14,
    imagesTout15,
    imagesTout16,
    imagesTout17,
    imagesTout18,
    imagesTout19,
    imagesTout20,
    imagesTout21,
    imagesTout22,
    imagesTout23,
    imagesTout24,
    imagesTout25,
    imagesTout26,
    imagesTout27,
    imagesTout28,
    imagesTout29
];

export default imagesTout;